import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import { readJsonString } from "../../../../util/json.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export class PacketInUnknownLobby extends PacketIn {
    public static readonly LOBBY_ID_KEY = "lobby_id";

    public lobbyID: string | null = null;

    constructor() {
        super(InboundPacketType.UNKNOWN_LOBBY);
    }

    override readContents(
        _context: MessageIOContext,
        json: Record<string, any>,
    ): void {
        this.lobbyID = readJsonString(json, PacketInUnknownLobby.LOBBY_ID_KEY);
    }
}
